import { render, staticRenderFns } from "./ModalSlot.vue?vue&type=template&id=706528ee"
import script from "./ModalSlot.vue?vue&type=script&lang=js"
export * from "./ModalSlot.vue?vue&type=script&lang=js"
import style0 from "./ModalSlot.vue?vue&type=style&index=0&id=706528ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports